import { FC, PropsWithChildren, ReactElement } from 'react';

import styles from './preference-status-tag-group.module.scss';

const PreferenceStatusTagGroup: FC<PropsWithChildren> = ({ children }): ReactElement => {
  return (
    <>
      <hr className={styles.divider} aria-hidden="true" />
      <div className={styles.container}>{children}</div>
    </>
  );
};

export default PreferenceStatusTagGroup;
